import { render, staticRenderFns } from "./QuoteDetailAssessmentSummary.vue?vue&type=template&id=058d3184&scoped=true"
import script from "./QuoteDetailAssessmentSummary.vue?vue&type=script&lang=js"
export * from "./QuoteDetailAssessmentSummary.vue?vue&type=script&lang=js"
import style0 from "./QuoteDetailAssessmentSummary.vue?vue&type=style&index=0&id=058d3184&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058d3184",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('058d3184')) {
      api.createRecord('058d3184', component.options)
    } else {
      api.reload('058d3184', component.options)
    }
    module.hot.accept("./QuoteDetailAssessmentSummary.vue?vue&type=template&id=058d3184&scoped=true", function () {
      api.rerender('058d3184', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quote/QuoteDetailAssessmentSummary.vue"
export default component.exports